// src/pages/Profile/Profile.tsx
import React from 'react';
import { User, Mail, Phone, MapPin, Calendar, Edit } from 'lucide-react';
import { useAppSelector } from '../../hooks/useAppSelector';
import './Profile.scss';

const Profile: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  // Fallbacks for profile display
  const name = user?.name || user?.userName || 'Unknown User';
  const email = user?.email || 'No email provided';
  const role = user?.role || 'Member';
  const joinDate = user?.createdAt 
    ? new Date(user.createdAt).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'Unknown';
  // Use ui-avatars to generate an avatar based on the real name
  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0073ea&color=fff&size=120`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-avatar-large">
          <img
            src={avatarUrl}
            alt="Profile"
          />
        </div>
        <div className="profile-info">
          <h1>{name}</h1>
          <p className="profile-role">{role}</p>
          <button className="edit-profile-btn">
            <Edit size={16} />
            Edit Profile
          </button>
        </div>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h2>Personal Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <User className="info-icon" />
              <div className="info-content">
                <label>Full Name</label>
                <p>{name}</p>
              </div>
            </div>
            <div className="info-item">
              <Mail className="info-icon" />
              <div className="info-content">
                <label>Email</label>
                <p>{email}</p>
              </div>
            </div>
            <div className="info-item">
              <Phone className="info-icon" />
              <div className="info-content">
                <label>Phone</label>
                <p>Not specified</p>
              </div>
            </div>
            <div className="info-item">
              <MapPin className="info-icon" />
              <div className="info-content">
                <label>Location</label>
                <p>Not specified</p>
              </div>
            </div>
            <div className="info-item">
              <Calendar className="info-icon" />
              <div className="info-content">
                <label>Joined</label>
                <p>{joinDate}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h2>About</h2>
          <p className="about-text">
            Experienced product manager with a passion for building innovative solutions
            that solve real-world problems. Focused on agile methodologies and user-centric design.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
